import { useSession } from '@common/hooks';
import { useLazyLoginQuery } from '@features/authentication';
import { AccountsSelectionPagePath } from '@router';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoginUI } from './LoginUI';

import { Title } from '@common/components/Title';
import { Layout } from '@common/layouts';
import { Box } from '@radix-ui/themes';

export const LoginPage = () => {
    useTranslation();
    const navigate = useNavigate();
    const [triggerLogin, { isLoading, isSuccess }] = useLazyLoginQuery();
    const { isAuthenticated } = useSession();

    React.useEffect(() => {
        if (isSuccess && isAuthenticated) {
            navigate(AccountsSelectionPagePath);
        }
    }, [isAuthenticated, isSuccess, navigate]);

    return (
        <Layout.Content centered>
            <Title size={'8'}>
                <Trans i18nKey={'login:title'} />
            </Title>
            <Box>
                <LoginUI handleSubmit={triggerLogin} isLoading={isLoading} />
            </Box>
        </Layout.Content>
    );
};
